import styled, { keyframes } from "styled-components";

import getPositionsArray from "./../../Canvas/unitPositionsArray";

export const entranceDelay = 950;

const entrance = keyframes`
    0% {
        opacity: 1;
        display: block;
    }
    95% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        display: none;
    }
`;

const EntranceImage = styled.img`
    animation: ${entrance} 1 ${entranceDelay / 1000}s ease-in-out;
    position: absolute;
    left: ${props => getPositionsArray(props.currentTheme)[props.location].left};
    top: ${props => getPositionsArray(props.currentTheme)[props.location].top};
    z-index: 100;
    min-height: ${props => props.imageSize + 50}px;
    min-width: ${props => props.imageSize + 50}px;
    max-width: ${props => props.imageSize}px;
    opacity: 0;
    display: block;
`;

EntranceImage.displayName = "EntranceImage";

export default EntranceImage;
